module.exports = __webpack_public_path__ + "static/media/feed.d13d11dd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/bottombar/feed.svg
// module id = ./src/statics/bottombar/feed.svg
// module chunks = 0